import { render, staticRenderFns } from "./MaximizePromo.vue?vue&type=template&id=2938101d&scoped=true&"
import script from "./MaximizePromo.vue?vue&type=script&lang=js&"
export * from "./MaximizePromo.vue?vue&type=script&lang=js&"
import style0 from "./MaximizePromo.vue?vue&type=style&index=0&id=2938101d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2938101d",
  null
  
)

export default component.exports